import { render, staticRenderFns } from "./PopularProducts.vue?vue&type=template&id=68739859&scoped=true"
import script from "./PopularProducts.vue?vue&type=script&lang=js"
export * from "./PopularProducts.vue?vue&type=script&lang=js"
import style0 from "./PopularProducts.vue?vue&type=style&index=0&id=68739859&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "68739859",
  null
  
)

export default component.exports